// extracted by mini-css-extract-plugin
export var text = "text-module--text--50f46";